import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { FileText } from 'lucide-react';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-yellow-50">
      <Navbar />
      
      <div className="container mx-auto px-4 py-8 mt-20">
        <Card className="max-w-4xl mx-auto shadow-xl">
          <CardHeader className="border-b">
            <div className="flex items-center gap-3">
              <FileText className="w-8 h-8 text-purple-600" />
              <CardTitle className="text-3xl font-bold">Mentions Légales</CardTitle>
            </div>
          </CardHeader>
          
          <CardContent className="p-8 space-y-8">
            {/* Éditeur du site */}
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-purple-600">1. Éditeur du site</h2>
              <div className="space-y-2 text-gray-700">
                <p><strong>Raison sociale :</strong> L'Alliance Humaine 2020</p>
                <p><strong>Forme juridique :</strong> Association loi 1901</p>
                <p><strong>SIREN :</strong> 888 686 904</p>
                <p><strong>SIRET :</strong> 888 686 904 00010</p>
                <p><strong>Siège social :</strong> 32 Allée Bajou, 94230 Cachan, France</p>
                <p><strong>Téléphone :</strong> 06 41 95 65 75</p>
                <p><strong>Email :</strong> contact@alliance-solidarite.org</p>
              </div>
            </section>

            {/* Directeur de publication */}
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-purple-600">2. Directeur de la publication</h2>
              <p className="text-gray-700">
                Antoine Cuttitta, Président de l'association L'Alliance Humaine 2020
              </p>
            </section>

            {/* Hébergement */}
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-purple-600">3. Hébergement</h2>
              <div className="space-y-2 text-gray-700">
                <p><strong>Hébergeur :</strong> Emergent AI</p>
                <p><strong>Site web :</strong> <a href="https://emergentagent.com" className="text-purple-600 hover:underline" target="_blank" rel="noopener noreferrer">emergentagent.com</a></p>
              </div>
            </section>

            {/* Propriété intellectuelle */}
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-purple-600">4. Propriété intellectuelle</h2>
              <p className="text-gray-700">
                L'ensemble du contenu du site Alliance Solidarité (structure, textes, logos, images, vidéos, etc.) est la propriété exclusive de l'association L'Alliance Humaine 2020, sauf mention contraire.
              </p>
              <p className="text-gray-700 mt-2">
                Toute reproduction, distribution, modification, adaptation, retransmission ou publication, même partielle, de ces différents éléments est strictement interdite sans l'accord exprès par écrit de l'association.
              </p>
            </section>

            {/* Protection des données */}
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-purple-600">5. Protection des données personnelles</h2>
              <p className="text-gray-700">
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
              </p>
              <p className="text-gray-700 mt-2">
                Pour exercer ces droits, vous pouvez nous contacter à l'adresse : <a href="mailto:contact@alliance-solidarite.org" className="text-purple-600 hover:underline">contact@alliance-solidarite.org</a>
              </p>
              <p className="text-gray-700 mt-2">
                Pour plus d'informations, consultez notre <a href="/politique-confidentialite" className="text-purple-600 hover:underline">Politique de Confidentialité</a>.
              </p>
            </section>

            {/* Cookies */}
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-purple-600">6. Cookies</h2>
              <p className="text-gray-700">
                Le site utilise des cookies techniques nécessaires au bon fonctionnement du site (authentification, préférences utilisateur). Ces cookies ne collectent aucune donnée personnelle à des fins commerciales.
              </p>
            </section>

            {/* Responsabilité */}
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-purple-600">7. Limitation de responsabilité</h2>
              <p className="text-gray-700">
                L'association L'Alliance Humaine 2020 s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, elle ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site.
              </p>
              <p className="text-gray-700 mt-2">
                L'association décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site.
              </p>
            </section>

            {/* Droit applicable */}
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-purple-600">8. Droit applicable</h2>
              <p className="text-gray-700">
                Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.
              </p>
            </section>

            {/* Date */}
            <section className="pt-4 border-t">
              <p className="text-sm text-gray-500">
                Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
              </p>
            </section>
          </CardContent>
        </Card>
      </div>

      <Footer />
    </div>
  );
};

export default MentionsLegales;
